import React, { useEffect, useState } from "react";
import vndrAprvlService from "../Services/Service";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  TextField,
  CircularProgress,
} from "@mui/material";
import RegistrationForm from "./Registration/RegistartionForm";
import { DataGrid } from "@mui/x-data-grid";

const VendorApprovalView = () => {
  const [rows, setRows] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [open, setOpen] = useState(false);
  const [approvalStatus, setApprovalStatus] = useState("");
  const [remark, setRemark] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("success");
  const [countdown, setCountdown] = useState(null);
  const [isUndoActive, setIsUndoActive] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [formVendorId, setFormVendorId] = useState(null);

  const [remarkError, setRemarkError] = useState(false);

  useEffect(() => {
    vndrAprvlService.setApiUrl(
      sessionStorage.getItem("APIUrl") + "/api/VndrAprvl",
    );

    fetchVndrAprvlDtls();
  }, []);

  // Countdown timer for undo functionality
  useEffect(() => {
    if (countdown !== null && countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0) {
      // Finalize the submission after countdown completes
      finalizeSubmission();
      setCountdown(null);
      setIsUndoActive(false);
    }
  }, [countdown]);

  const fetchVndrAprvlDtls = async () => {
    //let vUserName = "bipradas.guin@mendine.com";

    const vUserName = sessionStorage.getItem("userEmail");

    console.log(vUserName);
    vndrAprvlService.setApiUrl(
      sessionStorage.getItem("APIUrl") + "/api/VndrAprvl",
    );
    const res = await vndrAprvlService.getVndrAprvrDtls(vUserName);

    // API returns array → res.data is an array
    const mappedRows = res.data.map((item) => ({
      id: item.vendorID,
      name: item.vendorName,
      contact: item.contactPerson,
      email: item.mailID,
      createdByName: item.createdByName,
      status:
        item.aprvrStat === "P"
          ? "Pending"
          : item.aprvrStat === "A"
            ? "Approved"
            : item.aprvrStat === "R"
              ? "Rejection"
              : item.aprvrStat,
      rawData: item, // keep original data if needed later
    }));
    debugger;
    setRows(mappedRows);
  };

  const handleOpen = (row) => {
    setSelectedVendor(row);
    setApprovalStatus(""); // Reset dropdown
    setRemark(""); // Reset remark
    setMessage("");
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedVendor(null);
    setApprovalStatus("");
    setRemark("");
    setMessage("");
    setOpen(false);
  };

  // const handleApprovalStatusChange = (event) => {
  //   setApprovalStatus(event.target.value);
  // };

  const handleApprovalStatusChange = (event) => {
    setApprovalStatus(event.target.value);
    setRemarkError(false);
  };

  const handleRemarkChange = (event) => {
    setRemark(event.target.value);
  };

  const handleSubmit = async () => {
    if (!approvalStatus) {
      setMessage("Please select an approval status");
      setMessageType("error");
      return;
    }

    setLoading(true);

    try {
      // Call your API to update vendor approval status
      // Replace with your actual API call
      const aprvrStatValue = approvalStatus === "Approved" ? "A" : "R";
      const payload = {
        vendorID: selectedVendor.id,
        vendorName: selectedVendor.name,
        contactPerson: selectedVendor.contact,
        mailID: selectedVendor.email,
        aprvrStat: aprvrStatValue,
        opFlag: "Update",
        aprvlRem: remark,
      };

      // vndrAprvlService.setApiUrl(
      //   sessionStorage.getItem("APIUrl") + "/api/VndrAprvl",
      // );

      // Uncomment and update with your actual API method
      const res = await vndrAprvlService.updateVendorApproval(payload);
      console.log("API Response:", res.data);
      console.log("Payload Sent:", payload);

      // For now, showing success message
      setMessage(
        `Vendor "${selectedVendor.name}" approval is pending for 10 seconds. Click UNDO to cancel.`,
      );
      setMessageType("success");
      setIsUndoActive(true);
      setCountdown(10); // Start 10-second countdown
      setLoading(false);
    } catch (error) {
      setMessage("Error updating vendor status. Please try again.");
      setMessageType("error");
      console.error("Error:", error);
      setLoading(false);
    }
  };

  const finalizeSubmission = async () => {
    try {
      //debugger;
      // Prepare the API payload based on selected approval status
      const aprvrStatValue = approvalStatus === "Approved" ? "A" : "R";
      const Mail = sessionStorage.getItem("userEmail");

      const payload = {
        vendorID: selectedVendor.id,
        vendorName: selectedVendor.name,
        contactPerson: selectedVendor.contact,
        mailID: Mail,
        aprvrStat: aprvrStatValue,
        opFlag: "Update",
        aprvlRem: remark,
      };

      console.log("Finalizing vendor approval submission", payload);

      // Call the API to finalize the approval (uncomment to enable)
      const res = await vndrAprvlService.updateVendorApproval(payload);

      // Refresh the vendor list after successful approval
      await fetchVndrAprvlDtls();

      // Show success message
      setMessage(
        `Vendor "${selectedVendor.name}" has been successfully ${approvalStatus.toLowerCase()}ed!`,
      );
      setMessageType("success");
    } catch (error) {
      console.error("Error finalizing vendor approval:", error);
      setMessage("Error finalizing vendor approval. Please try again.");
      setMessageType("error");
    } finally {
      handleClose();
    }
  };

  const handleUndo = () => {
    setCountdown(null);
    setIsUndoActive(false);
    setApprovalStatus("");
    setRemark("");
    setMessage("Vendor approval cancelled successfully!");
    setMessageType("error");
    setTimeout(() => {
      handleClose();
    }, 1500);
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "name", headerName: "Vendor Name", flex: 1 },
    { field: "contact", headerName: "Contact Person", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },
    {
      field: "createdByName",
      headerName: "Created By",
      flex: 1,
    },
    { field: "status", headerName: "Status", width: 130 },
    {
      field: "actions",
      headerName: "Actions",
      width: 140,
      renderCell: (params) => (
        <Button
          variant="contained"
          size="small"
          onClick={() => handleViewApprove(params.row)}
        >
          View
        </Button>
      ),
    },
  ];

  const handleViewApprove = (row) => {
    // open registration form in dialog for viewing/editing
    setSelectedVendor(row);
    setApprovalStatus("");
    setRemark("");
    setFormVendorId(row.id);
    setFormOpen(true);
  };

  const approveVendor = async (row) => {
    setLoading(true);
    try {
      const payload = {
        vendorID: row.id,
        vendorName: row.name,
        contactPerson: row.contact,
        mailID: sessionStorage.getItem("userEmail") || row.email || "",
        aprvrStat: "A",
        opFlag: "Update",
        aprvlRem: "",
      };
      const res = await vndrAprvlService.updateVendorApproval(payload);
      setMessage(`Vendor "${row.name}" approved.`);
      setMessageType("success");
      await fetchVndrAprvlDtls();
    } catch (err) {
      console.error("Approve error", err);
      setMessage("Error approving vendor");
      setMessageType("error");
    } finally {
      setLoading(false);
      // clear message after short timeout
      setTimeout(() => setMessage(""), 2500);
    }
  };

  const rejectVendor = async (row) => {
    setLoading(true);
    try {
      const payload = {
        vendorID: row.id,
        vendorName: row.name,
        contactPerson: row.contact,
        mailID: sessionStorage.getItem("userEmail") || row.email || "",
        aprvrStat: "R",
        opFlag: "Update",
        aprvlRem: "",
      };
      const res = await vndrAprvlService.updateVendorApproval(payload);
      setMessage(`Vendor "${row.name}" rejected.`);
      setMessageType("success");
      await fetchVndrAprvlDtls();
    } catch (err) {
      console.error("Reject error", err);
      setMessage("Error rejecting vendor");
      setMessageType("error");
    } finally {
      setLoading(false);
      setTimeout(() => setMessage(""), 2500);
    }
  };

  const handleCloseForm = async () => {
    setFormOpen(false);
    setFormVendorId(null);
    // reset local form approval state and refresh list to pick up any changes
    setApprovalStatus("");
    setRemark("");
    setSelectedVendor(null);
    try {
      await fetchVndrAprvlDtls();
    } catch (e) {
      /* ignore */
    }
  };

  const handleFormSubmit = async () => {
    // if (!approvalStatus) {
    //   setMessage("Please select an approval status");
    //   setMessageType("error");
    //   return;
    // }

    // setLoading(true);

    if (approvalStatus === "Rejected" && !remark.trim()) {
      setRemarkError(true);
      return;
    }

    setRemarkError(false);
    setLoading(true);
    try {
      const aprvrStatValue = approvalStatus === "Approved" ? "A" : "R";
      const Mail =
        sessionStorage.getItem("userEmail") ||
        (selectedVendor && selectedVendor.email) ||
        "";

      const payload = {
        vendorID: selectedVendor.id,
        vendorName: selectedVendor.name,
        contactPerson: selectedVendor.contact,
        mailID: Mail,
        aprvrStat: aprvrStatValue,
        opFlag: "Update",
        aprvlRem: remark,
      };

      console.log("========== PAYLOAD ==========");
      console.log(payload);
      console.log("Vendor ID:", payload.vendorID);
      console.log("Mail ID:", payload.mailID);
      console.log("Status:", payload.aprvrStat);
      console.log("Remark:", payload.aprvlRem);

      vndrAprvlService.setApiUrl(
        sessionStorage.getItem("APIUrl") + "/api/VndrAprvl",
      );

      const res = await vndrAprvlService.updateVendorApproval(payload);
      console.log("========== API RESPONSE ==========");
      console.log(res);
      console.log(res.data);

      setMessage(
        `Vendor \"${selectedVendor.name}\" has been ${approvalStatus.toLowerCase()}ed.`,
      );
      setMessageType("success");
      await fetchVndrAprvlDtls();
      setFormOpen(false);
      setFormVendorId(null);
      setSelectedVendor(null);
      setApprovalStatus("");
      setRemark("");
    } catch (error) {
      console.error("Error submitting approval:", error);
      setMessage("Error submitting approval. Please try again.");
      setMessageType("error");
    } finally {
      setLoading(false);
      // clear transient messages after short delay
      setTimeout(() => setMessage(""), 3000);
    }
  };

  return (
    // <Box sx={{ height: 400, width: "100%", p: 2 }}>
    <Box sx={{ width: "100%", p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Vendor Approval View
      </Typography>

      {/* <DataGrid rows={rows} columns={columns} pageSize={5} /> */}
      <DataGrid rows={rows} columns={columns} autoHeight pageSize={5} />

      <Dialog open={formOpen} onClose={handleCloseForm} fullWidth maxWidth="md">
        <DialogTitle>Vendor Registration</DialogTitle>
        <DialogContent dividers>
          {formVendorId ? (
            <>
              {/* <RegistrationForm vendorId={formVendorId} mode={"edit"} /> */}
              <RegistrationForm vendorId={formVendorId} isViewMode={true} />

              {/* Approval controls shown alongside the registration form */}
              <Box sx={{ mt: 2 }}>
                {selectedVendor && (
                  <Card variant="outlined" sx={{ mb: 2 }}>
                    <CardContent>
                      <Typography variant="subtitle1">
                        Reviewing: {selectedVendor.name}
                      </Typography>
                      <Typography variant="body2">
                        Contact: {selectedVendor.contact}
                      </Typography>
                      <Typography variant="body2">
                        Email: {selectedVendor.email}
                      </Typography>
                    </CardContent>
                  </Card>
                )}

                <FormControl fullWidth sx={{ mt: 1 }}>
                  <InputLabel id="form-approval-status-label">
                    Approval Action
                  </InputLabel>
                  <Select
                    labelId="form-approval-status-label"
                    id="form-approval-status"
                    value={approvalStatus}
                    onChange={handleApprovalStatusChange}
                    label="Approval Action"
                    disabled={loading}
                  >
                    <MenuItem value="">
                      <em>Select an action...</em>
                    </MenuItem>
                    <MenuItem value="Approved">Approve</MenuItem>
                    <MenuItem value="Rejected">Reject</MenuItem>
                  </Select>
                </FormControl>

               
                <TextField
                  fullWidth
                  label="Remark"
                  multiline
                  rows={3}
                  value={remark}
                  onChange={(e) => {
                    setRemark(e.target.value);
                    if (e.target.value.trim() !== "") {
                      setRemarkError(false);
                    }
                  }}
                  placeholder="Enter remarks"
                  variant="outlined"
                  sx={{ mt: 2 }}
                  disabled={loading}
                  required={approvalStatus === "Rejected"}
                  error={remarkError}
                  helperText={
                    remarkError
                      ? "Remark is required when rejecting vendor"
                      : ""
                  }
                />
              </Box>
            </>
          ) : (
            <Typography>Loading...</Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ display: "flex", gap: 1 }}>
          <Button
            onClick={handleCloseForm}
            color="secondary"
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color={
              approvalStatus === "Approved"
                ? "success"
                : approvalStatus === "Rejected"
                  ? "error"
                  : "primary"
            }
            onClick={handleFormSubmit}
            disabled={loading || !approvalStatus}
          >
            {loading ? "Submitting..." : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Vendor Details</DialogTitle>
        <DialogContent>
          {message && (
            <Alert severity={messageType} sx={{ mb: 2 }}>
              {message}
            </Alert>
          )}

          {selectedVendor && (
            <>
              <Card variant="outlined" sx={{ mt: 2, mb: 3 }}>
                <CardContent>
                  <Typography variant="h6">{selectedVendor.name}</Typography>
                  <Typography>
                    <strong>Contact:</strong> {selectedVendor.contact}
                  </Typography>
                  <Typography>
                    <strong>Email:</strong> {selectedVendor.email}
                  </Typography>
                  <Typography>
                    <strong>Status:</strong> {selectedVendor.status}
                  </Typography>
                </CardContent>
              </Card>

              {/* Approval Status Dropdown */}
              <FormControl fullWidth sx={{ mt: 2 }}>
                <InputLabel id="approval-status-label">
                  Approval Status
                </InputLabel>
                <Select
                  labelId="approval-status-label"
                  id="approval-status"
                  value={approvalStatus}
                  onChange={handleApprovalStatusChange}
                  label="Approval Status"
                  disabled={loading}
                >
                  <MenuItem value="">
                    <em>Select an action...</em>
                  </MenuItem>
                  <MenuItem value="Approved">Approve</MenuItem>
                  <MenuItem value="Rejected">Reject</MenuItem>
                </Select>
              </FormControl>

              {/* Remark Text Box */}
              <TextField
                fullWidth
                label="Remark"
                multiline
                rows={4}
                value={remark}
                onChange={handleRemarkChange}
                placeholder="Enter your remarks (optional)"
                variant="outlined"
                sx={{ mt: 2 }}
                disabled={loading}
              />
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleClose}
            color="secondary"
            disabled={loading || isUndoActive}
          >
            Cancel
          </Button>
          {isUndoActive ? (
            <>
              <Typography variant="body2" sx={{ mr: 2, color: "orange" }}>
                Finalizing in {countdown}s
              </Typography>
              <Button
                variant="contained"
                color="warning"
                onClick={handleUndo}
                disabled={countdown === null}
              >
                Undo
              </Button>
            </>
          ) : (
            <Button
              variant="contained"
              color={
                approvalStatus === "Approved"
                  ? "success"
                  : approvalStatus === "Rejected"
                    ? "error"
                    : "inherit"
              }
              onClick={handleSubmit}
              disabled={loading || !approvalStatus}
            >
              {loading ? "Submitting..." : "Submit"}
            </Button>
          )}
        </DialogActions>

        {/* Loader Dialog Box */}
        <Dialog
          open={isUndoActive}
          maxWidth="xs"
          fullWidth
          disableEscapeKeyDown
        >
          <DialogContent sx={{ textAlign: "center", py: 4 }}>
            <CircularProgress sx={{ mb: 2 }} />
            <Typography variant="h6" gutterBottom>
              Processing Vendor Approval
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Time Remaining: <strong>{countdown}s</strong>
            </Typography>
            <Typography
              variant="caption"
              sx={{ mt: 2, display: "block", color: "orange" }}
            >
              Click UNDO to cancel within 10 seconds
            </Typography>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
            <Button
              variant="contained"
              color="warning"
              onClick={handleUndo}
              disabled={countdown === null}
              sx={{ minWidth: 120 }}
            >
              Undo
            </Button>
          </DialogActions>
        </Dialog>
      </Dialog>
    </Box>
  );
};

export default VendorApprovalView;
